// @flow
import type { Action } from '../actions/layout';

const initialState = {
  withSearchHero: true
};

export type State = {
  withSearchHero: boolean
};

export default function layout(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'SET_WITH_SEARCH_HERO':
      return {
        ...state,
        withSearchHero: action.payload.withSearchHero
      };
    default:
      return state;
  }
}
